import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../constants';
import { useAdUnit } from '../useAdUnit';
const DesktopProfileVideo = /*#__PURE__*/ React.memo(({ safety ='unlikely'  })=>{
    const slotAttr = useAdUnit(AdProviders.Nitro, ADUNIT_MAP['DesktopProfileVideo'], safety, {
        format: 'video-nc',
        video: {},
        skipBidders: [
            'google'
        ]
    });
    if (slotAttr.advertIsOff) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
DesktopProfileVideo.displayName = 'DesktopProfileVideo';
export default DesktopProfileVideo;
